import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { ANALYTICS_COVERAGE, CONVERSATIONAL_INDUSTRY_FIT, getContactUrl } from '../../../content/enterpriseMessaging';
import SectionSurface from '../shared/SectionSurface';

export default function AIModelSolutions() {
  return (
    <SectionSurface variant="elevated" decor="circuit" bleed="both" flowTop flowBottom overlap className="section">
      <div className="container-x">
        <div className="mx-auto max-w-4xl text-center">
          <p className="eyebrow">Streamlit · Power BI · Conversational analytics</p>
          <h2 className="mt-3 text-balance text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-ink-900">
            Interactive analytics and conversational intelligence.
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-pretty text-lg leading-relaxed text-ink-600">
            {ANALYTICS_COVERAGE.intro}
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs font-semibold uppercase tracking-wide text-ink-500">
              {CONVERSATIONAL_INDUSTRY_FIT.label}
            </span>
            {CONVERSATIONAL_INDUSTRY_FIT.industries.map((industry) => (
              <span
                key={industry}
                className="rounded-full bg-brand-50 px-3 py-1 text-xs font-medium text-brand-700"
              >
                {industry}
              </span>
            ))}
          </div>
          <div className="mt-8 flex min-w-0 items-center justify-center gap-3 flex-wrap">
            <a href={getContactUrl('ai-decision-agents')} className="btn-primary btn-lg">
              Book a discovery call
            </a>
            <a href="/semantic-hr" className="link-text">
              Explore Semantic HR
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </SectionSurface>
  );
}
